import { StretchPopup } from './stretchPopup';
import { RegLoginDoublePopup } from './regLoginDoublePopup';
import { ErrorToolTip, TooltipDirection } from '../general/newErrorToolTip';
import { Localization } from '../localization/localization';
import { CurrentPage } from '../pages/currentPage';
import { LandingEmailRegistration } from '../user/landingEmailRegistration';
import { FingerprintjsWrapper } from '../general/modules/fingerprintjs/FingerprintjsWrapper';
import { GtmSender } from '../marketing/GtmSender';
import { SystemEvents } from '../constants/gameEvents';
import { CheckboxValue, RegistrationProtocol } from '../user/registrationProtocol';
import { AuthStepConversionSend } from '../marketing/auth-step-conversion-send';
import { checkEmailAvailable } from './emailChecker';
import { checkPassword } from './passwordChecker';

export class RegistrationNicknamesPopup {
    private sendingInProgress = false;

    public constructor(private popup: JQuery) {
        this.getSetupFunc(1)();
        RegLoginDoublePopup.init();
    }

    public static initPopups() {
        $('.registration-4-step').each(function initReg4StepsHandlers() {
            new RegistrationNicknamesPopup($(this));

            console.log(this);
        });
    }

    private getSetupFunc = (stepNum: number) => {
        const authStepConversionSender = new AuthStepConversionSend(window.location);
        switch (stepNum) {
            case 1:
                return () => {
                    this.popup.find('.registration-4-step__step1-b-next').on('click', this.step1ButtonNextClick);
                };

            case 2:
                return () => {
                    authStepConversionSender.send('2');

                    this.popup.find('.registration-4-step__step2-b-next').click(this.step2ButtonNextClick);
                    this.popup.find('.registration-4-step__step2-b-prev').click(this.toPrevStep(1));
                };

            case 3:
                authStepConversionSender.send('3');

                return () => {
                    this.popup.find('.registration-4-step__register-without-consent').click(this.step3ButtonNextClick);
                    this.popup.find('.registration-4-step__step3-b-prev').click(this.toPrevStep(2));
                };
            default:
                throw new Error('unexpected step num');
        }
    };

    private isConsentAskingDisabled() {
        return this.popup.find('.registration-4-step__step3-b-next').length === 0;
    }

    private getTeardownFunc = (stepNum: number) => {
        switch (stepNum) {
            case 1:
                return () => {
                    this.popup.find('.registration-4-step__step1-b-next').off('click');
                };

            case 2:
                return () => {
                    this.popup.find('.registration-4-step__step2-b-next').off('click');
                    this.popup.find('.registration-4-step__step2-b-prev').off('click');
                };

            case 3:
                if (this.isConsentAskingDisabled()) {
                    this.popup.find('.registration-4-step__step3-b-next').off('click');
                } else {
                    return () => {
                        this.popup.find('.registration-4-step__step3-b-next').off('click');
                        this.popup.find('.registration-4-step__step3-b-prev').off('click');
                    };
                }
            case 4:
                return () => {
                    this.popup.find('.registration-4-step__register-without-consent').off('click');
                    this.popup.find('.registration-4-step__register-with-consent').off('click');
                    this.popup.find('.registration-4-step__step4-b-prev').off('click');
                };

            default:
                throw new Error('unexpected step num');
        }
    };

    private toNextStep = (stepNum: number) => {
        return () => {
            const currStep = stepNum - 1;
            const nextStep = stepNum;
            this.popup.find(`.registration-4-step__step${currStep}`).hide();
            this.popup.find(`.registration-4-step__step${nextStep}`).show();

            this.getTeardownFunc(currStep)();
            this.getSetupFunc(nextStep)();
            StretchPopup.stretch();
        };
    };

    private toPrevStep = (stepNum: number) => {
        return () => {
            const currStep = stepNum + 1;
            const prevStep = stepNum;

            this.popup.find(`.registration-4-step__step${currStep}`).hide();
            this.popup.find(`.registration-4-step__step${prevStep}`).show();

            this.getTeardownFunc(currStep)();
            this.getSetupFunc(prevStep)();
            StretchPopup.stretch();
        };
    };

    private step1ButtonNextClick = () => {
        this.toNextStep(2)();
    };

    private step2ButtonNextClick = async() => {
        const emailField = this.popup.find('input[type=email]');
        const tooltip = ErrorToolTip.getTooltipElement();

        checkEmailAvailable(emailField, tooltip).then((result: boolean) => {
            if (result) {
                this.popup.find('.error').removeClass('error');
                this.toNextStep(3)();
            }
        });
    };

    private step3ButtonNextClick = async () => {
        const passwordField = this.popup.find('input[type=password]');
        const password: string = (passwordField.val() as string).trim();
        const tooltip = ErrorToolTip.getTooltipElement();
        if (password.length < 6) {
            tooltip.showTooltipElement(
                passwordField.parent(),
                TooltipDirection.LEFT,
                Localization._n('password_strength.0')
            );
            return;
        }

        if (checkPassword(password)) {
            tooltip.hide();
            this.popup.find('.error').removeClass('error');
            this.registerWithoutConsent();
        } else {
            passwordField.parent().addClass('error');
            tooltip.showTooltipElement(
                passwordField.parent(),
                TooltipDirection.UP,
                Localization._n('errors.pass_empty')
            );
        }
    };

    private lockRegButton = () => {
        this.sendingInProgress = true;
    };

    private releaseRegButton = () => {
        this.sendingInProgress = false;
    };

    private isLocked = () => {
        return this.sendingInProgress;
    };

    // @ts-ignore
    private registerWithConsent = () => {
        if (this.isLocked()) {
            return;
        }

        try {
            this.lockRegButton();
            this.register(true);
        } catch (error) {
            this.releaseRegButton();
            throw (error);
        }
    };

    private registerWithoutConsent = () => {
        if (this.isLocked()) {
            return;
        }

        try {
            this.lockRegButton();
            this.register(false);
        } catch (error) {
            this.releaseRegButton();
            throw (error);
        }
    };

    private getCsrfToken(): string {
        return $<HTMLInputElement>('[name="csrftoken"]').val() as string;
    }

    private async register(consent: boolean) {
        const confidenceScore = await FingerprintjsWrapper.getConfidenceScore();
        const emailField = this.popup.find('input[type=email]');
        const email: string = (emailField.val() as string).trim();
        const passwordField = this.popup.find('input[type=password]');
        const password: string = (passwordField.val() as string).trim();
        const state = this.popup.find('[name=state]').val();
        const tooltip = ErrorToolTip.getTooltipElement().getThemedCopy('tt-black');

        const regData: RegistrationProtocol = {
            confidence: confidenceScore,
            csrftoken: this.getCsrfToken(),
            email,
            // eslint-disable-next-line id-length
            lp: 1,
            password,
            receive_consent: (consent ? 'on' : 'off') as CheckboxValue,
            state
        };

        CurrentPage.setLoadingState();
        const [isSuccess, error] = await LandingEmailRegistration.register(regData);
        CurrentPage.disableLoadingState();
        if (isSuccess) {
            GtmSender.fireMarketing(SystemEvents.REGISTRATION);
            CurrentPage.reload();
        } else {
            this.releaseRegButton();
            tooltip.showTooltipElement(
                $('.registration-4-step__register-without-consent'),
                TooltipDirection.UP, error.message
            );
        }
    }
}
